import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IconsOptions } from '../../../styles/cms.config';

export const PAGE_FOOTER_BLOCK_ID = 'page-footer'; // back forward compatibility for already saved data

export const paymentMethodsOptions: NICmsContentField.IOption[] = [
    { key: 'logo-mastercard', title: 'Mastercard' },
    { key: 'logo-visa', title: 'Visa' },
    { key: 'logo-paypal', title: 'PayPal' },
    { key: 'logo-apple-pay', title: 'Apple Pay' },
    { key: 'logo-google-wallet', title: 'Google Wallet' },
    { key: 'logo-amex', title: 'American Express' },
    { key: 'logo-v12', title: 'V12' }
];

export const PAGE_FOOTER_BLOCK_CONFIG: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: PAGE_FOOTER_BLOCK_ID,
    onDemandOnly: true,
    block: {
        url: PAGE_FOOTER_BLOCK_ID,
        scope: 'website',
        autoload: 'prerender'
    },
    name: 'Page footer',
    description: 'Page footer component',
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'columns',
            title: 'Columns',
            itemName: 'column',
            maxSize: 4,
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'heading',
                    title: 'Column heading',
                    required: true
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'links',
                    title: 'Column links',
                    itemName: 'link',
                    fields: [
                        <NICmsContentField.IChoiceField>{
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Icon',
                            key: 'icon',
                            itemName: 'icon',
                            options: IconsOptions,
                            default: undefined
                        },
                        {
                            type: NICmsContentField.EFieldType.text,
                            key: 'label',
                            title: 'Label',
                            required: true
                        },
                        {
                            type: NICmsContentField.EFieldType.text,
                            key: 'link',
                            title: 'Link',
                            required: true
                        }, {
                            key: 'open_cookies_modal',
                            type: NICmsContentField.EFieldType.toggle,
                            title: 'Open cookies modal'
                        },
                        {
                            key: 'label_only_on_mobile',
                            type: NICmsContentField.EFieldType.toggle,
                            title: 'Label only on mobile'
                        }
                    ]
                }
            ]
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-newsletter',
            title: 'Newsletter'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'newsletter_heading',
            title: 'Newsletter heading',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'newsletter_copy',
            title: 'Newsletter copy',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'contact_us_link',
            title: 'Contact us link',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'find_store_link',
            title: 'Find store link',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'phone_number',
            title: 'Phone Number',
            required: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'links',
            title: 'Bottom Links',
            itemName: 'Item',
            itemNameField: 'text',
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Label',
                    required: true
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                {
                    key: 'open_cookies_modal',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Open cookies modal'
                }
            ]
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'payment_method_icons',
            title: 'Payment Method icons',
            itemName: 'payment method',
            fields: [
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Payment service',
                    required: true
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'icon',
                    title: 'Icon',
                    options: paymentMethodsOptions,
                    required: true
                }
            ]
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'social_icons',
            title: 'Social icons',
            itemName: 'social icon',
            fields: [
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Social icon',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image_desktop',
                    title: 'Social icon desktop',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'name',
                    title: 'Name',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Social Link'
                }
            ]
        }
    ]
}